<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Edit Survey</h4>
                    </div>
                    <div class="card-body">
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table
                        mode="remote"
                        :totalRows="totalRecords"
                        :isLoading="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPage: serverParams.perPage,
                            perPageDropdown: [10, 20, 50, 100, 200],
                        }"
                        :sort-options="{
                            enabled: true,
                            initialSortBy: {
                                field: 'PracticeID',
                                type: 'desc',
                            },
                        }"
                        :rows="rows"
                        :columns="columns"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <b-button size="sm"
                                            @click="editSurvey(props.row)"
                                            class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button>
                                    <b-button size="sm" @click="deleteSurvey(props.row.id)"
                                        class="mr-1 btn-danger text-white">
                                        Delete
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
    import Vue from "vue";
    import VueJsonToCsv from 'vue-json-to-csv'
    import SortedTablePlugin from "vue-sorted-table";
    import API from '@/api'
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; 
    Vue.component('vue-json-to-csv', VueJsonToCsv)
    Vue.use(SortedTablePlugin, {
        ascIcon: '<i class="ti-arrow-down"></i>',
        descIcon: '<i class="ti-arrow-up"></i>'
    });
    export default {
        name: 'edit_survey',
        data() {
            return {
                isDisabled: false,
                selected: true,
                unSelected: false,
                serverParams: {
                    sort: [
                        {
                            field: 'id', // example: 'name'
                            type: 'desc' // 'asc' or 'desc'
                        }
                    ],

                    page: 1, // what page I want to show
                    perPage: 10 // how many items I'm showing per page
                },
                columns: [
                    {
                        label: 'Survey Name',
                        field: 'surveyName',
                        filterable: false,
                    },
                    {
                        label: 'Action',
                        field: "action",
                        sortable: false,
                    },
                ],
                isLoading: false,
                rows: [],
                totalRecords: 0,
                spots: []
            };
        },
        methods: {
            editSurvey(survey) {
                this.$router.push({name: 'add_survey', params: {survey: survey}});
            },
            deleteSurvey(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    let data = {
                        id: id
                    }
                    API.deleteSurvey(
                        data,
                        data => {
                            this.loadItems();
                            this.$swal(
                                'Deleted!',
                                'Record has been deleted.',
                                'success'
                            )
                        },
                        err => {
                        })
                }
            })
            // this.$router.push({name: 'edit_Vendor', params: {user: member}});
        },
            loadItems() {
                this.isLoading = true;
                API.getAllSurveys(this.serverParams,
                    data => {
                        this.totalRecords = data.totalRecords;
                        this.rows = data.data.data;
                        this.isLoading = false;
                    }, err => {
                        this.isLoading = false;
                    })
            },
            
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },
            changeStatus(spot_id, event) {
                const data = {
                    id: spot_id,
                    status: (event.value === true) ? 'Active' : 'Inactive',
                }
                API.updateMemberStatus(data,
                    data => {
                        if (data.status === 200) {
                            this.$showNotification(data,"success")
                        }
                    }, err => {
                    })
            },
            onSortChange(params) {
            Vue.set(this.serverParams.sort, 0, {
                field: params[0].field,
                type: params[0].type,
            });
            this.loadItems();
        },

        },
        computed: {}
        ,
        mounted() {
            this.loadItems();
        }
    }
</script>
